import React, { Component } from "react";
import clsx from "clsx";

/**
 * Overlay modal used by every backoffice dialog. Closes on backdrop click and Escape.
 */
class BoModal extends Component {
	componentDidMount() {
		document.addEventListener("keydown", this.onKeyDown);
	}

	componentWillUnmount() {
		document.removeEventListener("keydown", this.onKeyDown);
	}

	onKeyDown = e => {
		if (e.key === "Escape" && this.props.onClose) this.props.onClose();
	};

	render() {
		const { title, icon, onClose, footer, footerLeft, children, wide, className } = this.props;
		return (
			<div className="bo-overlay bo-overlay--show" onMouseDown={e => e.target === e.currentTarget && onClose && onClose()}>
				<div className={clsx("bo-modal", { "bo-modal--wide": wide }, className)} role="dialog" aria-modal="true">
					<div className="bo-modal__head">
						<h3>
							{icon}
							{title}
						</h3>
						<button className="bo-modal__x" onClick={onClose} aria-label="Close" type="button">
							×
						</button>
					</div>
					<div className="bo-modal__body">{children}</div>
					{(footer || footerLeft) && (
						<div className="bo-modal__foot">
							{footerLeft && <div className="bo-modal__foot-left">{footerLeft}</div>}
							{footer}
						</div>
					)}
				</div>
			</div>
		);
	}
}

export default BoModal;
